import { render } from "./Fields.vue?vue&type=template&id=21f12240"
import script from "./Fields.vue?vue&type=script&lang=js"
export * from "./Fields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/wpcm/fields/Fields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "21f12240"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21f12240', __exports__)) {
    api.reload('21f12240', __exports__)
  }
  
  module.hot.accept("./Fields.vue?vue&type=template&id=21f12240", () => {
    api.rerender('21f12240', render)
  })

}


export default __exports__